import React from 'react';
import { shape, string, oneOf } from 'prop-types';
import BaseTile from 'components/tiles/BaseTile';
import BgImgTile from 'components/tiles/BgImgTile';

export default function ListingItem({ item, itemType, itemDirection }) {
    // Determine which tile component gets rendered
    switch (itemType) {
        case 'bgimg':
            return (
                <BgImgTile item={item} />
            );
        // add more below...
        default:
            return (
                <BaseTile item={item} itemDirection={itemDirection} />
            );
    }
}

ListingItem.propTypes = {
    item: shape({ title: string.isRequired }).isRequired,
    itemType: string.isRequired,
    itemDirection: oneOf(['horizontal', 'vertical'])
};

ListingItem.defaultProps = { itemDirection: 'horizontal' };



// WEBPACK FOOTER //
// ./src/components/filtered-listing/items/ListingItem.jsx